import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { btn, btnHoverStyle } from "./buttonStyles";

const spinStyle = `@keyframes save-btn-spin { to { transform: rotate(360deg); } }`;

const SaveButton = ({ handleClick, text, isSaving }) => {
  return (
    <>
      <style>{btnHoverStyle}{spinStyle}</style>
      <button
        type="button"
        onClick={handleClick}
        className="btn-modern"
        style={{ ...btn.base, ...btn.primary, opacity: isSaving ? 0.75 : 1, transition: "opacity 0.15s" }}
        disabled={isSaving}
      >
        {isSaving ? (
          <span style={{
            display: "inline-block",
            width: "13px", height: "13px",
            border: "2px dotted rgba(255,255,255,0.5)",
            borderTopColor: "#fff",
            borderRadius: "50%",
            animation: "save-btn-spin 0.75s linear infinite",
            flexShrink: 0,
          }} />
        ) : (
          <FontAwesomeIcon icon={faFloppyDisk} />
        )}
        {text ?? "Save"}
      </button>
    </>
  );
};

export default SaveButton;
